import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../../PricingHub/SearchComponent';

class TaxDetailSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.startDate',
      name: 'startDate',
      type: 'date',
    },
    {
      label: 'label.endDate',
      name: 'endDate',
      type: 'date',
    },
    {
      label: 'label.currency',
      name: 'currency',
    },
    {
      label: 'label.objectType',
      name: 'objectType',
      type: 'select',
      tOptions: 'selections:objectType',
      isClearable: true,
    },
    {
      label: 'label.taxCode',
      name: 'taxcode',
    },
    {
      label: 'label.taxCategory',
      name: 'taxCategory',
    },
    {
      label: 'label.taxJurisdictionLevel',
      name: 'jurisdiction',
      type: 'select',
      tOptions: 'selections:jurisdiction',
      isClearable: true,
    },
    {
      label: 'label.state',
      name: 'state',
    },
    {
      label: 'label.country',
      name: 'country',
    },
    {
      label: 'label.invoiceStatus',
      name: 'invoiceStatus',
      tOptions: 'selections:invoiceStatus',
      isClearable: true,
      type: 'select',
    },
    {
      label: 'label.organization',
      name: 'company',
    },
  ];

  btnSpan = 'col-md-3';
}

TaxDetailSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

TaxDetailSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(TaxDetailSearchForm);
